import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';
import { AbilityService } from '../../../_shared/services/ability.service';
import { UtilService } from '../../../_shared/services/util.service';

import { LanguageService } from '../../../languages/shared/language.service';

import { Category } from '../../shared/category.model';
import { CategoryService } from '../../shared/category.service';
import { CategoryListComponent } from '../../category-list/category-list.component';
import { CategoryDetailComponent } from '../../category-detail/category-detail.component';

@Component({
  selector: 'app-categories-modal',
  templateUrl: './categories-modal.component.html',
  standalone: true,
  imports: [SharedModule, CategoryListComponent, CategoryDetailComponent],
})
export class CategoriesModalComponent {
  constructor(
    private categoryService: CategoryService,
    private languageService: LanguageService,
    private abilityService: AbilityService,
    private utilService: UtilService,
    private ref: MatDialogRef<CategoriesModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getAdditionalLanguages();
  }

  // @Output() private dialogSaved = new EventEmitter<any>(); // avoid closing the dialog

  modalTitle = this.data.title;
  // lang = this.data.params.lang;

  categories: Category[];
  meta = [];
  category: Category;
  mode = '';
  loadingCategories = false;

  listMode = true;
  detailMode = false;

  permissions = {
    canList: this.abilityService.can('index_category_accountadmin'),
    canCreate: this.abilityService.can('create_category_accountadmin'),
  };

  defaultLanguage: any;

  private filterCriteria = this.categoryService.getFilterCriteria();
  additionalLanguages = [];

  showCategories() {
    this.modalTitle = this.data.title;

    this.listMode = true;
    this.detailMode = false;

    this.getCategories();
  }

  addCategory() {
    this.modalTitle = 'ADD_CATEGORY';
    this.listMode = false;
    this.detailMode = true;

    this.category = {};
  }

  // Referenced from app-category-detail
  onSavedCategory(category) {
    this.category = category;

    this.listMode = true;
    this.detailMode = false;

    this.getCategories(category);
  }

  // Referenced from app-category-detail
  onCanceledCategory() {
    this.showCategories();
  }

  close() {
    this.ref.close(true);
  }

  // Referenced from app-category-list
  onSelectedCategory({ category, mode = '' }) {
    this.category = category;
    this.mode = mode;

    this.modalTitle = 'CATEGORY_DETAILS';
    this.listMode = false;
    this.detailMode = true;
  }

  private getCategories(selectedCategory = null) {
    this.filterCriteria.lang = this.defaultLanguage.lang;
    // this.filterCriteria['skip_check_role'] = true;

    this.loadingCategories = true;
    this.categoryService.getCategories(this.filterCriteria).subscribe((response) => {
      this.categories = response.data;
      this.meta = response.meta;

      this.loadingCategories = false;

      if (selectedCategory) {
        this.utilService.changeItemRowStyle(selectedCategory.id);
      }
    });
  }

  private getAdditionalLanguages() {
    this.languageService.getLanguages({ skip_check_role: true }).subscribe((response) => {
      this.defaultLanguage = response.data.find((language) => language.is_default);
      this.additionalLanguages = response.data.filter((language) => !language.is_default);

      this.getCategories();
    });
  }
}
